import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
`

export const Input = styled.input`
  width: 100%;
  height: 32px;
  padding: ${({ theme }) => theme.spacing.small}
    ${({ theme }) => theme.spacing.default};
  /* Extra right padding to accommodate clear button */
  padding-right: 35px;
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  border-radius: ${({ theme }) => theme.borderRadius.default};
  background: ${({ theme }) => theme.colors.background.primary};
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  font-family: ${({ theme }) => theme.typography.fontFamily.sans};
  transition: ${({ theme }) => theme.transitions.default};

  &::placeholder {
    color: ${({ theme }) => theme.colors.text.tertiary};
  }

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.border.focus};
    box-shadow: ${({ theme }) => theme.shadows.focus};
  }

  &:disabled {
    background: ${({ theme }) => theme.colors.background.tertiary};
    color: ${({ theme }) => theme.colors.text.tertiary};
    cursor: not-allowed;
  }

  /* Mobile: Ensure minimum touch target and prevent iOS zoom */
  @media (max-width: 1023px) {
    height: ${({ theme }) => theme.touchTargets.comfortable};
    font-size: 16px;
    padding-right: 52px;
  }
`

export const ClearButton = styled.button`
  position: absolute;
  right: 3px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.text.tertiary};
  font-size: ${({ theme }) => theme.typography.fontSize.section};
  line-height: 1;
  /* Minimum touch target size */
  min-width: 26px;
  min-height: 26px;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  transition: ${({ theme }) => theme.transitions.default};

  &:hover {
    color: ${({ theme }) => theme.colors.text.secondary};
    background: ${({ theme }) => theme.colors.background.tertiary};
  }

  &:focus {
    outline: none;
    box-shadow: ${({ theme }) => theme.shadows.focus};
  }

  /* Mobile: Ensure minimum 44px touch target */
  @media (max-width: 1023px) {
    min-width: ${({ theme }) => theme.touchTargets.minimum};
    min-height: ${({ theme }) => theme.touchTargets.minimum};
  }

  /* Disable hover effects on touch devices */
  @media (hover: none) {
    &:hover {
      color: ${({ theme }) => theme.colors.text.tertiary};
      background: none;
    }

    &:active {
      color: ${({ theme }) => theme.colors.text.secondary};
      background: ${({ theme }) => theme.colors.background.tertiary};
    }
  }
`
